module.exports = __webpack_public_path__ + "img/default-avatar.c6b63a7d.jpg";